(function () {
    function escapeHtml(value) {
        return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function createMoneyFormatter(currency) {
        var locale = document.documentElement.lang || 'pt-BR';

        try {
            return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currency || 'BRL'
            });
        } catch (error) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        }
    }

    function formatMoney(cents, currency) {
        return createMoneyFormatter(currency).format((Number(cents) || 0) / 100);
    }

    function getVariantCompareAtPrice(variant) {
        if (!variant) {
            return 0;
        }

        return Number(
            variant.compare_at_price ||
            variant.compareAtPrice ||
            variant.compare_at_price_min ||
            variant.compare_at_price_max ||
            0
        );
    }

    function getProductHandle(product) {
        if (!product || !product.url) {
            return '';
        }

        var cleanUrl = String(product.url).split('?')[0].replace(/\/$/, '');
        var match = cleanUrl.match(/\/products\/([^/]+)$/);

        return match ? match[1] : '';
    }

    function fetchProductDetails(product, signal) {
        var handle = getProductHandle(product);

        if (!handle || (Array.isArray(product.variants) && product.variants.length)) {
            return Promise.resolve(product);
        }

        return fetch('/products/' + encodeURIComponent(handle) + '.js', {
            signal: signal,
            headers: {
                Accept: 'application/json'
            }
        })
            .then(function (response) {
                if (!response.ok) {
                    return product;
                }

                return response.json();
            })
            .then(function (productDetails) {
                if (!productDetails || !Array.isArray(productDetails.variants)) {
                    return product;
                }

                return Object.assign({}, product, {
                    product_type: product.product_type || productDetails.type,
                    variants: productDetails.variants
                });
            })
            .catch(function (error) {
                if (error.name === 'AbortError') {
                    throw error;
                }

                return product;
            });
    }

    function debounce(callback, delay) {
        var timeoutId = null;

        return function () {
            var args = arguments;

            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(function () {
                callback.apply(null, args);
            }, delay);
        };
    }

    function syncHeaderHeightVariable(headerElement) {
        if (!headerElement) {
            return;
        }

        var headerHeight = headerElement.offsetHeight;

        if (headerHeight) {
            document.documentElement.style.setProperty('--filadelfia-header-height', headerHeight + 'px');
        }
    }

    function toggleScrolledState(headerElement) {
        if (!headerElement) {
            return;
        }

        var hasScrolled = window.scrollY > 12;
        headerElement.classList.toggle('is-scrolled', hasScrolled);
    }

    function updateTopBarVisibility(headerElement, previousScrollY) {
        if (!headerElement) {
            return window.scrollY;
        }

        var currentScrollY = Math.max(window.scrollY || 0, 0);
        var scrollDelta = currentScrollY - previousScrollY;
        var directionThreshold = 6;

        if (!headerElement.querySelector('[data-header-top-bar]') || currentScrollY <= 12) {
            headerElement.classList.remove('is-top-bar-hidden');
            return currentScrollY;
        }

        if (scrollDelta > directionThreshold) {
            headerElement.classList.add('is-top-bar-hidden');
        } else if (scrollDelta < -directionThreshold) {
            headerElement.classList.remove('is-top-bar-hidden');
        }

        return currentScrollY;
    }

    function openDrawer(toggleButton, drawerElement) {
        toggleButton.setAttribute('aria-expanded', 'true');
        drawerElement.hidden = false;
        drawerElement.offsetHeight;
        drawerElement.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
    }

    function closeDrawer(toggleButton, drawerElement) {
        toggleButton.setAttribute('aria-expanded', 'false');
        drawerElement.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        window.setTimeout(function () {
            if (!drawerElement.classList.contains('is-open')) {
                drawerElement.hidden = true;
            }
        }, 320);
    }

    function closeAllSubmenus(drawerElement) {
        var submenuToggles = drawerElement.querySelectorAll('[data-drawer-submenu-toggle]');

        submenuToggles.forEach(function (submenuToggle) {
            submenuToggle.setAttribute('aria-expanded', 'false');
        });

        var submenus = drawerElement.querySelectorAll('[data-drawer-submenu]');

        submenus.forEach(function (submenuElement) {
            submenuElement.hidden = true;
        });
    }

    function openSubmenu(toggleButton, submenuElement) {
        toggleButton.setAttribute('aria-expanded', 'true');
        submenuElement.hidden = false;
    }

    function closeSubmenu(toggleButton, submenuElement) {
        toggleButton.setAttribute('aria-expanded', 'false');
        submenuElement.hidden = true;
    }

    function bindSubmenuEvents(drawerElement) {
        var submenuToggles = drawerElement.querySelectorAll('[data-drawer-submenu-toggle]');

        submenuToggles.forEach(function (submenuToggle) {
            submenuToggle.addEventListener('click', function () {
                var submenuElement = submenuToggle.parentElement.querySelector('[data-drawer-submenu]');

                if (!submenuElement) {
                    return;
                }

                var isExpanded = submenuToggle.getAttribute('aria-expanded') === 'true';

                if (isExpanded) {
                    closeSubmenu(submenuToggle, submenuElement);
                    return;
                }

                openSubmenu(submenuToggle, submenuElement);
            });
        });
    }

    function bindDrawerEvents(headerElement) {
        var toggleButton = headerElement.querySelector('[data-header-menu-toggle]');
        var drawerElement = headerElement.querySelector('[data-header-menu-drawer]');

        if (!toggleButton || !drawerElement) {
            return;
        }

        bindSubmenuEvents(drawerElement);

        toggleButton.addEventListener('click', function () {
            var isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
                headerElement.classList.remove('is-drawer-open');
                closeDrawer(toggleButton, drawerElement);
                closeAllSubmenus(drawerElement);
                return;
            }

            headerElement.classList.add('is-drawer-open');
            openDrawer(toggleButton, drawerElement);
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                headerElement.classList.remove('is-drawer-open');
                closeDrawer(toggleButton, drawerElement);
                closeAllSubmenus(drawerElement);
            }
        });

        window.addEventListener('resize', function () {
            if (window.innerWidth > 989) {
                headerElement.classList.remove('is-drawer-open');
                closeDrawer(toggleButton, drawerElement);
                closeAllSubmenus(drawerElement);
            }
        });
    }

    function initTopBarSlider(headerElement) {
        var sliderElement = headerElement.querySelector('[data-header-top-bar-slider]');

        if (!sliderElement || typeof window.Swiper === 'undefined') {
            return;
        }

        var slideCount = sliderElement.querySelectorAll('.swiper-slide').length;
        var previousButton = headerElement.querySelector('[data-header-top-bar-prev]');
        var nextButton = headerElement.querySelector('[data-header-top-bar-next]');

        if (sliderElement.swiper) {
            sliderElement.swiper.destroy(true, true);
        }

        if (slideCount <= 1) {
            if (previousButton) {
                previousButton.hidden = true;
            }

            if (nextButton) {
                nextButton.hidden = true;
            }

            return;
        }

        var autoplayEnabled = sliderElement.dataset.headerTopBarAutoplay === 'true';
        var loopEnabled = sliderElement.dataset.headerTopBarLoop === 'true';
        var autoplayDelay = Number(sliderElement.dataset.headerTopBarDelay) || 4000;

        new window.Swiper(sliderElement, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            speed: 520,
            loop: loopEnabled,
            watchOverflow: true,
            allowTouchMove: true,
            autoplay: autoplayEnabled ? {
                delay: autoplayDelay,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            } : undefined,
            navigation: previousButton && nextButton ? {
                prevEl: previousButton,
                nextEl: nextButton
            } : undefined
        });
    }

    function buildInstallmentMarkup(price, currency, installmentCount, installmentTextColor) {
        var count = Math.max(Number(installmentCount) || 3, 1);
        var installmentPrice = Math.floor((Number(price) || 0) / count);
        var colorStyle = installmentTextColor ? ' style="--product-installments-color: ' + escapeHtml(installmentTextColor) + ';"' : '';

        return '' +
            '<p class="filadelfia-collection-card__installments filadelfia-product-installments"' + colorStyle + '>' +
                '<span class="filadelfia-product-installments__icon" aria-hidden="true">' +
                    '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">' +
                        '<rect x="3.75" y="6.25" width="16.5" height="11.5" rx="2"></rect>' +
                        '<path d="M3.75 9.5h16.5"></path>' +
                        '<path d="M6.75 14.5h4.5"></path>' +
                    '</svg>' +
                '</span>' +
                '<span class="filadelfia-product-installments__text"><strong>' + count + ' x</strong> de <strong>' + escapeHtml(formatMoney(installmentPrice, currency)) + '</strong> sem juros</span>' +
            '</p>';
    }

    function buildSearchProductMarkup(product, currency, pixDiscountPercentage, installmentCount, installmentTextColor) {
        var imageMarkup = product.featured_image && product.featured_image.url
            ? '<img class="filadelfia-collection-card__image" src="' + escapeHtml(product.featured_image.url) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
            : '<span class="filadelfia-collection-card__image filadelfia-collection-card__image--empty">Produto sem imagem</span>';

        var pillText = product.product_type || '';
        var pillMarkup = pillText
            ? '<span class="filadelfia-collection-card__pill">' + escapeHtml(pillText) + '</span>'
            : '';

        var variant = null;

        if (Array.isArray(product.variants) && product.variants.length) {
            variant = product.variants.find(function (currentVariant) {
                return currentVariant.available;
            }) || product.variants[0];
        }

        var buttonMarkup = '';
        var priceMarkup = '';

        if (variant) {
            var isAvailable = variant.available !== false;
            var price = Number(variant.price) || 0;
            var compareAtPrice = getVariantCompareAtPrice(variant);
            var pixPrice = Math.floor(price * (100 - pixDiscountPercentage) / 100);

            priceMarkup = '<p class="filadelfia-collection-card__price-group">';

            if (compareAtPrice > price) {
                priceMarkup += '<s class="filadelfia-collection-card__compare-price">' + escapeHtml(formatMoney(compareAtPrice, currency)) + '</s>';
            }

            priceMarkup += '<span class="filadelfia-collection-card__price">' + escapeHtml(formatMoney(price, currency)) + '</span></p>';
            priceMarkup += '<p class="filadelfia-collection-card__pix">Pague por pix</p>';
            priceMarkup += buildInstallmentMarkup(price, currency, installmentCount, installmentTextColor);

            buttonMarkup = '' +
                '<div class="filadelfia-collection-card__actions">' +
                    '<a href="' + escapeHtml(product.url) + '" class="filadelfia-collection-card__button">' +
                        '<span class="filadelfia-collection__button-face">COMPRAR</span>' +
                    '</a>' +
                    '<form method="post" action="/cart/add" class="filadelfia-collection-card__cart-form">' +
                        '<input type="hidden" name="id" value="' + escapeHtml(variant.id) + '">' +
                        '<button type="submit" class="filadelfia-collection-card__cart-button" aria-label="Adicionar ' + escapeHtml(product.title) + ' ao carrinho"' + (isAvailable ? '' : ' disabled') + '>' +
                            '<span class="filadelfia-collection-card__cart-button-face">' +
                                '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
                                    '<path d="M4.7 7.65h14.6l.88 11.73c.07.93-.66 1.72-1.59 1.72H5.41c-.93 0-1.66-.79-1.59-1.72L4.7 7.65Z" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linejoin="round"/>' +
                                    '<path d="M8.45 7.65v-1.6A3.55 3.55 0 0 1 12 2.5a3.55 3.55 0 0 1 3.55 3.55v1.6" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"/>' +
                                '</svg>' +
                            '</span>' +
                        '</button>' +
                    '</form>' +
                '</div>' +
                (isAvailable ? '' : '<p class="filadelfia-collection-card__sold-out">Sem estoque</p>');
        }

        return '' +
            '<article class="filadelfia-collection-card">' +
                '<a href="' + escapeHtml(product.url) + '" class="filadelfia-collection-card__media">' +
                    imageMarkup +
                    '<div class="filadelfia-collection-card__topline">' + pillMarkup + '</div>' +
                '</a>' +
                '<div class="filadelfia-collection-card__body">' +
                    '<h3 class="filadelfia-collection-card__title"><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a></h3>' +
                    priceMarkup +
                    buttonMarkup +
                '</div>' +
            '</article>';
    }

    function bindSearchEvents(headerElement) {
        var openButton = headerElement.querySelector('[data-search-open]');
        var overlayElement = headerElement.querySelector('[data-search-overlay]');
        var closeButton = headerElement.querySelector('[data-search-close]');
        var formElement = headerElement.querySelector('[data-search-form]');
        var inputElement = headerElement.querySelector('[data-search-input]');
        var statusElement = headerElement.querySelector('[data-search-status]');
        var resultsElement = headerElement.querySelector('[data-search-results]');
        var resultsGridElement = headerElement.querySelector('[data-search-results-grid]');
        var currency = headerElement.getAttribute('data-search-currency') || 'BRL';
        var pixDiscountPercentage = Number(headerElement.getAttribute('data-product-pix-discount-percentage') || '3');
        var installmentCount = Number(headerElement.getAttribute('data-product-installment-count') || '3');
        var installmentTextColor = headerElement.getAttribute('data-product-installment-text-color') || '';
        var initialMessage = statusElement ? statusElement.textContent : '';
        var activeController = null;

        if (!openButton || !overlayElement || !closeButton || !formElement || !inputElement || !statusElement || !resultsElement || !resultsGridElement) {
            return;
        }

        function showStatus(message) {
            statusElement.hidden = false;
            statusElement.textContent = message;
            resultsElement.hidden = true;
            resultsGridElement.innerHTML = '';
        }

        function renderResults(products) {
            if (!products.length) {
                showStatus(overlayElement.dataset.searchNoResultsMessage || 'Nenhum produto encontrado para essa busca.');
                return;
            }

            resultsGridElement.innerHTML = products.map(function (product) {
                return buildSearchProductMarkup(product, currency, pixDiscountPercentage, installmentCount, installmentTextColor);
            }).join('');
            statusElement.hidden = true;
            resultsElement.hidden = false;
        }

        function openSearch() {
            inputElement.value = '';
            showStatus(initialMessage);
            overlayElement.hidden = false;
            overlayElement.offsetHeight;
            overlayElement.classList.add('is-open');
            overlayElement.setAttribute('aria-hidden', 'false');
            window.setTimeout(function () {
                inputElement.focus();
                inputElement.select();
            }, 30);
        }

        function closeSearch() {
            overlayElement.classList.remove('is-open');
            overlayElement.setAttribute('aria-hidden', 'true');

            window.setTimeout(function () {
                if (!overlayElement.classList.contains('is-open')) {
                    overlayElement.hidden = true;
                }
            }, 220);
        }

        function fetchProducts(query) {
            if (activeController) {
                activeController.abort();
            }

            activeController = new AbortController();
            showStatus('Buscando...');

            var endpoint = '/search/suggest.json?q=' + encodeURIComponent(query) +
                '&resources[type]=product' +
                '&resources[limit]=8' +
                '&resources[options][unavailable_products]=hide';

            fetch(endpoint, {
                signal: activeController.signal,
                headers: {
                    Accept: 'application/json'
                }
            })
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error('Falha ao buscar produtos.');
                    }

                    return response.json();
                })
                .then(function (data) {
                    var products = data && data.resources && data.resources.results && Array.isArray(data.resources.results.products)
                        ? data.resources.results.products
                        : [];

                    return Promise.all(products.map(function (product) {
                        return fetchProductDetails(product, activeController.signal);
                    }));
                })
                .then(function (products) {
                    renderResults(products);
                })
                .catch(function (error) {
                    if (error.name === 'AbortError') {
                        return;
                    }

                    showStatus('Não foi possível carregar os resultados agora.');
                });
        }

        var debouncedSearch = debounce(function (query) {
            if (!query) {
                showStatus(initialMessage);
                return;
            }

            fetchProducts(query);
        }, 180);

        openButton.addEventListener('click', function (event) {
            event.preventDefault();
            openSearch();
        });

        closeButton.addEventListener('click', function () {
            closeSearch();
        });

        overlayElement.addEventListener('click', function (event) {
            if (event.target === overlayElement) {
                closeSearch();
            }
        });

        inputElement.addEventListener('input', function () {
            debouncedSearch(inputElement.value.trim());
        });

        formElement.addEventListener('submit', function (event) {
            event.preventDefault();

            if (inputElement.value.trim()) {
                fetchProducts(inputElement.value.trim());
            } else {
                showStatus(initialMessage);
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && overlayElement.classList.contains('is-open')) {
                closeSearch();
            }
        });
    }

    function initSiteHeader(headerElement) {
        if (!headerElement || headerElement.dataset.initialized === 'true') {
            return;
        }

        headerElement.dataset.initialized = 'true';
        initTopBarSlider(headerElement);
        syncHeaderHeightVariable(headerElement);
        toggleScrolledState(headerElement);
        bindDrawerEvents(headerElement);
        bindSearchEvents(headerElement);

        var lastScrollY = Math.max(window.scrollY || 0, 0);
        lastScrollY = updateTopBarVisibility(headerElement, lastScrollY);

        window.addEventListener('scroll', function () {
            toggleScrolledState(headerElement);
            lastScrollY = updateTopBarVisibility(headerElement, lastScrollY);
        }, { passive: true });

        window.addEventListener('resize', function () {
            syncHeaderHeightVariable(headerElement);
        });
    }

    window.filadelfiaSiteHeader = {
        init: initSiteHeader
    };
})();
